import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import CustomModal from '../../../CustomModal/CustomModal'
import { deleteSpaceAsync } from '../../../../Manage/actions'
import styles from './DeleteSpaceModal.module.css'

const DeleteSpaceModal = ({ isOpen, spaceId, spaceName, onClose, onSuccess }) => {
  const dispatch = useDispatch()
  const [confirmName, setConfirmName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen) {
      setConfirmName('')
      setError('')
    }
  }, [isOpen])

  const isConfirmValid = confirmName === spaceName

  const handleDelete = async () => {
    if (!isConfirmValid) {
      setError('Please enter the exact space name to confirm deletion')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      dispatch(deleteSpaceAsync(spaceId))
      onSuccess && onSuccess()
      onClose()
      setIsLoading(false)
    } catch (error) {
      setError('Failed to delete space. Please try again.')
      setIsLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isConfirmValid) {
      handleDelete()
    } else if (e.key === 'Escape') {
      onClose()
    }
  }

  const handleClose = () => {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <CustomModal show={isOpen} onHide={handleClose} centered size="md" className={styles.modal}>
      <div className="p-4">
        <Modal.Header closeButton className={styles.header}>
          <Modal.Title className={styles.title}>Delete space?</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          <div className={styles.warningSection}>
            <div className={styles.warningIcon}>⚠️</div>
            <div className={styles.warningContent}>
              <p className={styles.warningText}>
                If you delete this space, all projects within this space will be moved to your live projects.
              </p>
              <p className={styles.confirmText}>
                To confirm deletion, please enter the space name: <strong>{spaceName}</strong>
              </p>
            </div>
          </div>

          <div className={styles.inputGroup}>
            <input
              type="text"
              value={confirmName}
              onChange={(e) => setConfirmName(e.target.value)}
              onKeyDown={handleKeyDown}
              className={styles.input}
              placeholder={spaceName}
              autoFocus
              disabled={isLoading}
            />
            {error && <div className={styles.error}>{error}</div>}
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <Button variant="outline-secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={isLoading || !isConfirmValid}
            className={styles.deleteButton}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </div>
    </CustomModal>
  )
}

export default DeleteSpaceModal
